"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectTimeFormatOption', function selectTimeFormatOption(timeFormat) {
    var optionState = store_1.default();
    optionState.selectedTimeFormat = timeFormat;
});
//# sourceMappingURL=selectTimeFormatOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/selectTimeFormatOption.js
// module id = 4941
// module chunks = 2